'use strict';

var processInclude = require('BASE/util');

$(document).ready(function() {  
  processInclude(require('./search/search'));
  $('body').on('click', 'button.filter-results', function() {
    if ($('.refinement-bar, .modal-background').hasClass('d-md-none')) {
      $('.refinement-bar, .modal-background').removeClass('d-md-none');
    }
  });
  
});

$(document).ready(function() { 
  $(document).on('click', '.btn-change-gift', function() {
    var flagIsdiff = $('#flagIsdiff').val();
    var giftChangeForm = $(this).closest('form');
    if (flagIsdiff === 'true'){
      $('#formCard').val('');
      $('#notification-card').data('giftChangeForm', giftChangeForm).show();
    } else {
      giftChangeForm.submit();
    }
    
  }); 
});

$(document).on('click', '#proceedModalCard', function() {
  var giftChangeForm = $('#notification-card').data('giftChangeForm');
  if (!giftChangeForm || !giftChangeForm.length) {
    return;
  }
  giftChangeForm.find('[name="emptyCart"]').val(true);
  $("#notification-card").hide();
  giftChangeForm.submit();
});

$(document).on('click', '#closeModalCard', function() {
  $('#notification-card').removeData('giftChangeForm').hide();
});

document.addEventListener('DOMContentLoaded', function() {  
  var buttons = document.getElementsByClassName('btn-download-gift');  
  for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function() {
          var voucherUrl = this.getAttribute('data-voucher-url');

          if (voucherUrl) {              
              window.open(voucherUrl, '_blank');
          } else {              
              alert('Il voucher non è disponibile per il download.');
          }
      });
  }
});
